var getSurfaceBg = function (surface) {
  return function (el, s) {
    var td = s.root.toothData && s.root.toothData[s.num]
    var toothType = td && td.type
    if (toothType === 'missing') return 'toothMissing'
    if (toothType === 'implant') return 'toothImplant'
    if (toothType === 'bridge') return 'toothBridge'
    if (toothType === 'braces') return 'toothBraces'
    var st = td && td.surfaces && td.surfaces[surface]
    if (st === 'caries') return 'toothCaries'
    if (st === 'restored') return 'toothRestored'
    if (st === 'crown') return 'toothCrown'
    return 'toothHealthy'
  }
}

var getBuccalBg = function (el, s) {
  var td = s.root.toothData && s.root.toothData[s.num]
  var toothType = td && td.type
  if (toothType === 'missing') return 'toothMissing'
  if (toothType === 'implant') return 'toothImplant'
  if (toothType === 'bridge') return 'toothBridge'
  if (toothType === 'braces') return 'toothBraces'
  if (toothType === 'veneer') return 'toothVeneer'
  var st = td && td.surfaces && td.surfaces.buccal
  if (st === 'caries') return 'toothCaries'
  if (st === 'restored') return 'toothRestored'
  if (st === 'crown') return 'toothCrown'
  return 'toothHealthy'
}

export const ToothSVG = {
  position: 'relative',
  width: 'C',
  height: 'C',
  cursor: 'pointer',
  border: (el, s) => {
    var td = s.root.toothData && s.root.toothData[s.num]
    var toothType = td && td.type
    if (s.root.selectedTooth === s.num) return '2px solid toothSelected'
    if (toothType === 'bridge') return '2px dashed blue'
    return '2px solid inkBorder'
  },
  round: 'Y',
  background: (el, s) => {
    var td = s.root.toothData && s.root.toothData[s.num]
    var toothType = td && td.type
    if (toothType === 'missing') return 'toothMissing'
    if (toothType === 'implant') return 'toothImplant'
    return 'inkMid'
  },
  opacity: (el, s) => {
    var td = s.root.toothData && s.root.toothData[s.num]
    var toothType = td && td.type
    if (toothType === 'missing') return '0.5'
    return '1'
  },
  overflow: 'hidden',

  Buccal: {
    position: 'absolute',
    top: '0',
    left: '50%',
    transform: 'translateX(-50%)',
    width: 'Z2',
    height: 'Z',
    round: 'X',
    cursor: 'pointer',
    background: getBuccalBg,
    border: (el, s) => {
      var td = s.root.toothData && s.root.toothData[s.num]
      var toothType = td && td.type
      if (toothType === 'veneer') return '2px solid purple'
      return '1px solid inkBorder'
    },
    onClick: (el, s) => {
      s.root.update({ selectedTooth: s.num, selectedSurface: 'buccal' })
    }
  },

  Lingual: {
    position: 'absolute',
    bottom: '0',
    left: '50%',
    transform: 'translateX(-50%)',
    width: 'Z2',
    height: 'Z',
    round: 'X',
    cursor: 'pointer',
    background: getSurfaceBg('lingual'),
    border: '1px solid inkBorder',
    onClick: (el, s) => {
      s.root.update({ selectedTooth: s.num, selectedSurface: 'lingual' })
    }
  },

  Mesial: {
    position: 'absolute',
    left: '0',
    top: '50%',
    transform: 'translateY(-50%)',
    width: 'Z',
    height: 'Z2',
    round: 'X',
    cursor: 'pointer',
    background: getSurfaceBg('mesial'),
    border: '1px solid inkBorder',
    onClick: (el, s) => {
      s.root.update({ selectedTooth: s.num, selectedSurface: 'mesial' })
    }
  },

  Occlusal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'Z2',
    height: 'Z2',
    round: 'X',
    cursor: 'pointer',
    background: getSurfaceBg('occlusal'),
    border: '1px solid inkBorder',
    onClick: (el, s) => {
      s.root.update({ selectedTooth: s.num, selectedSurface: 'occlusal' })
    }
  },

  Distal: {
    position: 'absolute',
    right: '0',
    top: '50%',
    transform: 'translateY(-50%)',
    width: 'Z',
    height: 'Z2',
    round: 'X',
    cursor: 'pointer',
    background: getSurfaceBg('distal'),
    border: '1px solid inkBorder',
    onClick: (el, s) => {
      s.root.update({ selectedTooth: s.num, selectedSurface: 'distal' })
    }
  },

  MissingMarker: {
    if: (el, s) => {
      var td = s.root.toothData && s.root.toothData[s.num]
      return td && td.type === 'missing'
    },
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: '10',
    tag: 'span',
    text: 'X',
    fontSize: 'A',
    fontWeight: '800',
    color: 'red',
    pointerEvents: 'none'
  },

  BracesOverlay: {
    if: (el, s) => {
      var td = s.root.toothData && s.root.toothData[s.num]
      return td && td.type === 'braces'
    },
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: '10',
    width: 'Z2',
    height: '3px',
    background: 'inkSubtle',
    round: 'X',
    pointerEvents: 'none',

    BracketLeft: {
      position: 'absolute',
      left: '0',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '4px',
      height: 'Y',
      background: 'inkSubtle',
      round: 'X'
    },
    BracketRight: {
      position: 'absolute',
      right: '0',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '4px',
      height: 'Y',
      background: 'inkSubtle',
      round: 'X'
    }
  },

  ToothStatusBadge: {
    if: (el, s) => {
      var td = s.root.toothData && s.root.toothData[s.num]
      var tp = td && td.type
      return tp === 'implant' || tp === 'braces' || tp === 'bridge' || tp === 'veneer'
    },
    position: 'absolute',
    top: '-2px',
    right: '-2px',
    zIndex: '20',
    width: 'Y2',
    height: 'Y2',
    round: 'C',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
    background: (el, s) => {
      var td = s.root.toothData && s.root.toothData[s.num]
      var tp = td && td.type
      if (tp === 'implant') return 'purple'
      if (tp === 'braces') return 'green'
      if (tp === 'bridge') return 'blue'
      if (tp === 'veneer') return 'purple'
      return 'inkMuted'
    },

    BadgeIcon: {
      extends: 'Icon',
      icon: (el, s) => {
        var td = s.root.toothData && s.root.toothData[s.num]
        var tp = td && td.type
        if (tp === 'implant') return 'pin'
        if (tp === 'braces') return 'link'
        if (tp === 'bridge') return 'minus'
        if (tp === 'veneer') return 'layers'
        return 'circle'
      },
      fontSize: 'W2',
      color: 'white'
    }
  }
}
